import { CurveAbstractTrade } from 'src/features/on-chain/calculation-manager/providers/dexes/common/curve-provider/curve-abstract-trade';

export class CurveGnosisTrade extends CurveAbstractTrade {}
